var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoomOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0262 13.8473L18.5953 17.4157L17.4162 18.5948L13.8478 15.0257C12.5201 16.09 10.8687 16.6689 9.16699 16.6665C5.02699 16.6665 1.66699 13.3065 1.66699 9.1665C1.66699 5.0265 5.02699 1.6665 9.16699 1.6665C13.307 1.6665 16.667 5.0265 16.667 9.1665C16.6694 10.8682 16.0905 12.5196 15.0262 13.8473ZM13.3545 13.229C14.4121 12.1414 15.0027 10.6835 15.0003 9.1665C15.0003 5.94317 12.3895 3.33317 9.16699 3.33317C5.94366 3.33317 3.33366 5.94317 3.33366 9.1665C3.33366 12.389 5.94366 14.9998 9.16699 14.9998C10.684 15.0022 12.1419 14.4116 13.2295 13.354L13.3545 13.229ZM5.83366 8.33317H12.5003V9.99984H5.83366V8.33317Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default __webpack_public_path__ + "static/media/zoom-out.2d21e386abf1107720543ace02e0bbbb.svg";
export { ForwardRef as ReactComponent };